export enum ReportState {
  sent = "sent",
  unsent = "unsent",
}
